import React, { useState, useEffect, useRef } from 'react';
import api from '../services/api';

const TIPO_CONFIG = {
  mora:               { color:'#EF4444', icon:'⚠', bg:'rgba(239,68,68,0.08)' },
  proximo_vencimiento:{ color:'#F59E0B', icon:'⏰', bg:'rgba(245,158,11,0.08)' },
  ticket:             { color:'#6366F1', icon:'🎫', bg:'rgba(99,102,241,0.08)' },
  // La tienda. Antes un pedido no avisaba por aquí: el único canal era el correo, y cuando
  // el correo dejó de salir el pedido entraba sin que nadie se enterara.
  pedido_web:         { color:'#14B8A6', icon:'🛒', bg:'rgba(20,184,166,0.10)' },
  pago_web:           { color:'#22C55E', icon:'💳', bg:'rgba(34,197,94,0.10)' },
  solicitud_plan:     { color:'#00E5FF', icon:'📶', bg:'rgba(0,229,255,0.08)' },
  // Ambar: no es un pago, es una excepción que se concedió y que sigue debiéndose.
  reconexion_sin_pago:{ color:'#FCD34D', icon:'🔓', bg:'rgba(245,158,11,0.10)' },
};

export default function Notificaciones() {
  const [abierto, setAbierto] = useState(false);
  const [notifs, setNotifs] = useState([]);
  const [noLeidas, setNoLeidas] = useState(0);
  const [generando, setGenerando] = useState(false);
  const ref = useRef(null);

  const cargar = async () => {
    try {
      const [resN, resC] = await Promise.all([
        api.get('/api/notificaciones'),
        api.get('/api/notificaciones/no-leidas'),
      ]);
      setNotifs(resN.data);
      setNoLeidas(resC.data.total);
    } catch (e) {}
  };

  useEffect(() => {
    cargar();
    const interval = setInterval(cargar, 60000); // actualizar cada minuto
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const handler = (e) => { if (ref.current && !ref.current.contains(e.target)) setAbierto(false); };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  const abrir = async () => {
    setAbierto(!abierto);
    if (!abierto && noLeidas > 0) {
      try {
        await api.put('/api/notificaciones/marcar-leidas');
        setNoLeidas(0);
      } catch (e) {}
    }
  };

  const generarAlertas = async () => {
    setGenerando(true);
    try {
      const { data } = await api.post('/api/notificaciones/generar');
      await cargar();
      alert(data.mensaje);
    } catch (e) { alert('Error al generar alertas'); }
    finally { setGenerando(false); }
  };

  return (
    <div ref={ref} style={s.wrapper}>
      <button style={s.campana} onClick={abrir}>
        🔔
        {noLeidas > 0 && <span style={s.badge}>{noLeidas > 9 ? '9+' : noLeidas}</span>}
      </button>

      {abierto && (
        <div style={s.panel}>
          <div style={s.panelHeader}>
            <span style={s.panelTitulo}>Notificaciones</span>
            <button style={s.btnGenerar} onClick={generarAlertas} disabled={generando}>
              {generando ? '...' : '⚡ Generar alertas'}
            </button>
          </div>
          <div style={s.lista}>
            {notifs.length === 0 ? (
              <div style={s.vacio}>Sin notificaciones</div>
            ) : notifs.map(n => {
              const cfg = TIPO_CONFIG[n.tipo] || { color:'#fff', icon:'📋', bg:'rgba(255,255,255,0.04)' };
              return (
                <div key={n.id} style={{ ...s.item, background: n.leida ? 'transparent' : cfg.bg }}>
                  <span style={{ fontSize:'18px' }}>{cfg.icon}</span>
                  <div style={{ flex:1 }}>
                    <div style={{ ...s.itemTitulo, color: cfg.color }}>{n.titulo}</div>
                    {n.mensaje && <div style={s.itemMsg}>{n.mensaje}</div>}
                    <div style={s.itemFecha}>{new Date(n.creado_en).toLocaleDateString('es-CO')}</div>
                  </div>
                  {!n.leida && <span style={s.puntito} />}
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
}

const s = {
  wrapper: { position:'relative' },
  campana: { background:'rgba(255,255,255,0.06)', border:'1px solid rgba(255,255,255,0.1)', borderRadius:'8px', width:'36px', height:'36px', cursor:'pointer', fontSize:'16px', position:'relative', display:'flex', alignItems:'center', justifyContent:'center' },
  badge: { position:'absolute', top:'-6px', right:'-6px', background:'#EF4444', color:'#fff', fontSize:'10px', fontWeight:'700', borderRadius:'10px', minWidth:'18px', height:'18px', display:'flex', alignItems:'center', justifyContent:'center', padding:'0 4px' },
  panel: { position:'absolute', top:'44px', right:'0', width:'340px', background:'#131929', border:'1px solid rgba(255,255,255,0.12)', borderRadius:'14px', boxShadow:'0 20px 50px rgba(0,0,0,0.5)', zIndex:1000, overflow:'hidden' },
  panelHeader: { display:'flex', justifyContent:'space-between', alignItems:'center', padding:'14px 16px', borderBottom:'1px solid rgba(255,255,255,0.08)' },
  panelTitulo: { fontSize:'14px', fontWeight:'700' },
  btnGenerar: { background:'rgba(0,229,255,0.1)', border:'1px solid rgba(0,229,255,0.2)', borderRadius:'6px', padding:'4px 10px', color:'#00E5FF', fontSize:'11px', cursor:'pointer' },
  lista: { maxHeight:'400px', overflowY:'auto' },
  vacio: { padding:'30px', textAlign:'center', color:'rgba(255,255,255,0.3)', fontSize:'13px' },
  item: { display:'flex', gap:'10px', padding:'12px 16px', borderBottom:'1px solid rgba(255,255,255,0.05)', alignItems:'flex-start' },
  itemTitulo: { fontSize:'13px', fontWeight:'600', marginBottom:'3px' },
  itemMsg: { fontSize:'12px', color:'rgba(255,255,255,0.5)', lineHeight:'1.4' },
  itemFecha: { fontSize:'11px', color:'rgba(255,255,255,0.3)', marginTop:'4px' },
  puntito: { width:'8px', height:'8px', borderRadius:'50%', background:'#00E5FF', flexShrink:0, marginTop:'6px' },
};
